import React, { useContext, useCallback } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';

import { LinkDatePicker } from 'ui-components/components/link-date-picker';

import Global from '../../../../../store/global-selectors';

import { MarkAsShippedContext } from '../../../context';
import { stopPropagation, getShipDate } from '../../../helper';

import style from '../style.module.less';

const ShipDate = ({ fulfillmentPlanId }) => {
  const {
    fulfillmentPlans: { [fulfillmentPlanId]: { shipDate } = {} },
    updateFulfillmentPlan,
  } = useContext(MarkAsShippedContext);

  const dateFormat = useSelector(Global.selectUserUserDateFormat);

  const onChange = useCallback(
    (date) => {
      const isoDate = getShipDate(date, dateFormat);
      updateFulfillmentPlan(fulfillmentPlanId, 'shipDate', isoDate);
    },
    [updateFulfillmentPlan, fulfillmentPlanId, dateFormat],
  );

  const formattedDate = moment(shipDate).utc();

  return (
    <div onClick={stopPropagation}>
      <LinkDatePicker
        allowPastDates
        dateFormat={dateFormat}
        linkButtonClassName={style['date-link']}
        onChange={onChange}
        value={formattedDate}
      />
    </div>
  );
};

ShipDate.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
};

export default ShipDate;
